import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = {
  key: 1,
  class: "title"
}
const _hoisted_3 = { class: "d-row" }
const _hoisted_4 = ["checked"]
const _hoisted_5 = { class: "buttons" }

import { RateItem } from "@/services/entities/RateItem";
import { useVfm, VueFinalModal } from "vue-final-modal";
import ConfirmModal from "./ConfirmModal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'RateFormModal',
  props: {
    value: { Type: {} as RateItem, default: {} as RateItem },
},
  emits: ["create", "close", "edit"],
  setup(__props, { emit: __emit }) {

const vfm = useVfm();
const confirmModalId = Symbol("confirmModalId");
const emit = __emit;

function beforeClose() {
    vfm.open(confirmModalId);
}

const props = __props;

function create() {
    emit("create");
}

function edit() {
    emit("edit");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueFinalModal), {
    class: "modal",
    "content-class": "modal-content",
    "overlay-transition": "vfm-fade",
    clickToClose: false,
    onClickOutside: beforeClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (props.value.id)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, "Edit Rate"))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, "Create Rate")),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _cache[7] || (_cache[7] = _createElementVNode("label", { for: "r_name" }, "Name", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "r_name",
              type: "string",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((props.value.name) = $event))
            }, null, 512), [
              [_vModelText, props.value.name]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { for: "r_value" }, "Value", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "r_value",
              type: "number",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((props.value.value) = $event))
            }, null, 512), [
              [_vModelText, props.value.value]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { for: "i_description" }, "Description", -1)),
            _withDirectives(_createElementVNode("textarea", {
              id: "i_description",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((props.value.description) = $event))
            }, null, 512), [
              [_vModelText, props.value.description]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[10] || (_cache[10] = _createElementVNode("label", { for: "r_currency" }, "Currency", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "r_currency",
              type: "string",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((props.value.currency) = $event))
            }, null, 512), [
              [_vModelText, props.value.currency]
            ])
          ]),
          _createElementVNode("div", null, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { for: "r_active" }, "Active", -1)),
            _createElementVNode("input", {
              id: "r_active",
              type: "checkbox",
              checked: !props.value.disabled,
              onChange: _cache[4] || (_cache[4] = ($event: any) => (props.value.disabled = !$event?.target?.checked))
            }, null, 40, _hoisted_4)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", { onClick: beforeClose }, "Cancel"),
        (props.value.id)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "accent",
              onClick: edit
            }, "Save changes"))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "accent",
              onClick: create
            }, "Create rate"))
      ]),
      _createVNode(ConfirmModal, {
        "modal-id": _unref(confirmModalId),
        text: "You have unsaved changes, do you really want to leave this form?",
        "confirm-text": "Close form",
        onConfirm: _cache[5] || (_cache[5] = () => {
                _unref(vfm).close(_unref(confirmModalId));
                emit('close');
            }
                ),
        onClose: _cache[6] || (_cache[6] = ($event: any) => (_unref(vfm).close(_unref(confirmModalId))))
      }, null, 8, ["modal-id"])
    ]),
    _: 1
  }))
}
}

})